import StyledSwitch from '@/components/StyledInputFields/StyledSwitch.tsx';
import {
  BrowserNotificationPermission,
  useBrowserNotificationPreference,
} from '@/hooks/browserNotificationPreference.ts';
import { Stack, Text } from '@mantine/core';

function getStatusText(permission: BrowserNotificationPermission) {
  if (permission === 'unsupported') return 'Browser notifications are unavailable.';
  if (permission === 'denied') return 'Browser notifications are blocked.';
  if (permission === 'granted') return 'Browser notifications are allowed.';
  return 'Browser permission has not been requested.';
}

export default function BrowserNotificationSettingsPanel() {
  const { enabled, permission, setEnabled } = useBrowserNotificationPreference();

  const disabled = permission === 'unsupported' || permission === 'denied';

  return (
    <Stack gap={6}>
      <StyledSwitch
        checked={enabled}
        disabled={disabled}
        label="Notify when runs finish or need attention"
        onChange={(event) => {
          void setEnabled(event.currentTarget.checked);
        }}
      />
      <Text size="xs" c="dimmed">
        {getStatusText(permission)}
      </Text>
    </Stack>
  );
}
